import { useHistory, useLocation } from "react-router-dom";
import { Tabs } from "antd";
import { useMemo } from "react";
import EstampSubTabs from "./EstampSubTabs"; // Import the modularized component
import { isSuper } from "../../../utils/permission";
import useAuthStore from "../../../states/useAuth";

const MainTabs = () => {
  const history = useHistory();
  const location = useLocation();
  const { user } = useAuthStore();

  // Dynamically determine tab items
  const tabItems = useMemo(() => {
    if (user?.role === "approver") {
      return [{ key: "distribute", label: "Distribute" }]; // Only show "Distribute" for approver
    } else if (user?.role === "merchantUser") {
      const baseItems = [
        { key: "distribute", label: "Distribute" },
        { key: "redeem", label: "Redeem" },
      ];

      if (user?.permission?.report == "all") {
        baseItems.push({ key: "transfer", label: "Transfer" });
        baseItems.push({ key: "coin", label: "Coin" });
      }

      baseItems.push({ key: "discount", label: "Discount" });
      return baseItems;
    }
  }, [user]);

  // Determine the main tab key
  const currentTabKey = useMemo(() => {
    const pathSegments = location.pathname.split("/");
    const lastSegment = pathSegments[pathSegments.length - 1];
    const secondLastSegment = pathSegments[pathSegments.length - 2];
    return secondLastSegment === "coin" ? "coin" : lastSegment;
  }, [location.pathname]);

  // Determine the sub-tab key for "coin"
  const currentEstampSubTabKey = useMemo(() => {
    const pathSegments = location.pathname.split("/");
    const lastSegment = pathSegments[pathSegments.length - 1];
    return ["earn", "transfer", "redeem"].includes(lastSegment) ? lastSegment : "earn"; // Default to "earn" if not specified
  }, [location.pathname]);

  return (
    <>
      <Tabs
        activeKey={currentTabKey}
        size="large"
        items={tabItems}
        onChange={(key) => {
          if (key === "coin") {
            history.push(`/merchantUser/report/coin/earn`);
          } else {
            history.push(`/merchantUser/report/${key}`);
          }
        }}
      />

      {currentTabKey === "coin" && (
        <EstampSubTabs
          activeSubKey={currentEstampSubTabKey}
          onChange={(key) => {
            if (currentEstampSubTabKey == key) {
              return;
            } // prevent navigate to same url
            history.push(`/merchantUser/report/coin/${key}`);
          }}
        />
      )}
    </>
  );
};

export default MainTabs;
